<template>
  <b-form :submit="login" class="login" hide-action-buttons>
    <div class="login__header">
      <div style="font-size: 20px">Вітаємо в <b>inTime</b></div>
      <div>
        <RouterLink :to="{ name: 'forgot-password' }" class="link">
          Забули пароль?
        </RouterLink>
      </div>
    </div>
    <span class="login__auth-text">Вхід</span>
    <div class="login__form">
      <b-label>
        <span class="login__form text">Корпоративна пошта</span>
      </b-label>
      <b-input
        v-model="credentials.email"
        :mask="emailMask"
        :error-messages="getErrorMessages(loginV$.email)"
        class="mb-3">
      </b-input>
      <b-label>
        <span class="login__form text">Пароль</span>
      </b-label>
      <b-input-password
        v-model="credentials.password"
        :error-messages="getErrorMessages(loginV$.password)"
        class="mb-3">
      </b-input-password>
      <v-btn
        :loading="$loading.isLoading('loginFirst')"
        class="w-100 login__form"
        size="large"
        type="submit">
        <span>Ввійти в систему</span>
        <i class="pi pi-arrow-right ml-2"></i>
      </v-btn>
    </div>
  </b-form>
</template>

<script setup lang="ts">
import { BForm, BInput, BInputPassword, BLabel } from 'best-modules/components'
import { emailMask } from 'best-modules/utils'
import { getErrorMessages } from '@/utils/helpers'
import { initAuth } from './auth'

defineOptions({
  name: 'LoginPage',
})

const { credentials, loginV$, login } = initAuth()
</script>

<style lang="scss" scoped>
.login {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__form {
    .text {
      font-size: 16px;
      font-weight: 400;
      color: #323232;
      display: block;
      margin-bottom: 12px;
    }

    .btn {
      background: #0f6ac1;
      color: #fff;
      border-radius: 4px !important;
    }
  }

  &__auth-text {
    font-size: 34px;
    color: #1f1f1f;
    font-weight: 700;
    display: block;
    margin: 15px 0;
  }

  &__auth-btn {
    background: #0f6ac1;
    border-radius: 4px;
  }
}
</style>
